<template>
  <div>
    <div class="check-popup-list" v-if="!$isMobile()">
      <div @click="openModal('knowledge')">
        {{ $t("messages.titLookupSaftyEducationData") }}
      </div>
      <div>
        <el-checkbox v-model="value" :label="$t('messages.lblConfirm')" 
          :disabled="!isWrite || !popUpCheck || isTemplate"
          @change="checkBoxCheck"/>
      </div>
    </div>
    <el-collapse v-else>
      <el-collapse-item name="1">
        <template slot="title">
          <span class="el-collapse-item__title">
            {{ collapseList.title }}
          </span>
          <el-checkbox
            v-model="collapseList.value"
            :label="$t('messages.lblConfirm')"
          />
        </template>
        <div>
          <div class="ly-title">
            <div class="title">{{ collapseList.listTit }}</div>
            <i class="icon-X"></i>
          </div>
          <!-- 22.03.14 누락사항 반영 openModal 추가-->
          <idc-list
            :tableHeader="collapseList.tableHeader"
            :tableData="collapseList.tableData"
            @clickRow="openModal('knowledge')"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 지식분류/안전교육자료 -->
    <idc-modal
      :visible.sync="dialogKnowledgeView"
      :title="$t('messages.titKnowledgeClassification')"
      width="1400px"
    >
      <template #content>
        <view-knowledge-modal v-if="!$isMobile()"
          :key="Date.now()"/>
        <div v-else>
          <div class="desc-tit">자료정보</div>
          <el-form ref="form" label-width="120px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="IDC명"> 목동1IDC </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="등록일">
                  2021-11-19 00:00:00
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="자료유형"> 안전교육자료 </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="위치"> 1F </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="등록자"> 홍길동 </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="desc">
            <div class="desc-list">
              <div class="desc-list-tit">첨부자료</div>
              <div class="desc-list-txt">
                <div v-for="(item, index) in knowledge" :key="index">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </idc-modal>
  </div>
</template>

<script>
import IdcList from "@/components/common/IdcList";
import ViewKnowledgeModal from "@/components/listComponents/wrkComponents/ViewKnowledgeModal.vue";
import IdcModal from "@/components/common/IdcModal.vue";

export default {
  components: { IdcList,
                ViewKnowledgeModal,
                IdcModal,
  },
  created() {
    if (this.$isMobile()) {
      this.$EventBus.$on("rowClick", (row) => {
        //지식분류/안전교육자료
        // 22.03.14 누락사항 반영
        // this.openModal("knowledge");
      });
    }
  },
  mounted(){
    this.getWrkDatconfresltList(true);
  },
  props: {
    openToggle: {
      value: Boolean,
      dafault: false,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    isWrite: {
      type: Boolean,
      default: true,
    },
    isTemplate: {
      type: Boolean,
      default: true,
    },
    assetTypeCd: {
      type: String,
      default: ''
    },
    prcssTrtDataCnctId: {
      type: String,
      default: "",
    }, 
    exeWflowId: {
      type: String,
      default: ''
    },
    idcCd: {
      type: String,
      default:"",
    },
    ticketInfo: {
      type: Object,
      default: () => {},
    },
    //상위 공정 ID
    mainPrcssId: { 
      type: String,
      default: ''
    },
    //하위 공정 ID
    subPrcssId: {
      type: String,
      default: ''
    },
    scrnId: {
      type: String,
      default: ''
    },
    wflowScrnId: {
      type: String,
      default: ''
    },
    scrnGetApi: {
      type: String,
      default: ''
    },
    scrnPostApi: {
      type: String,
      default: ''
    },
    scrnPutApi: {
      type: String,
      default: ''
    },
    scrnDeleteApi: {
      type: String,
      default: ''
    },
    wflowScrnId: {
      type: String,
      default: ''
    },
    mandDataChkYn:{
      type: String,
      default: 'N'
    },
    sftyChkMandChkYn: {
      type: String,
      default: 'N'
    },
    sftyChkScrnYn: {
      type: String,
      default: 'N'
    },
    callDate: {
      type: Number,
      default: -1
    },
    stepCd: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      value: null,
      dialogKnowledgeView: false,
      popUpCheck: false,
      currPrcssTrtDataCnctId:"",
      datDivCd: "2", //TODO 구분코드정해지면 설정 예정
      collapseList: {
        title: "안전교육자료 조회",
        value: false,
        listTit: "지식자료 - 안전교육자료",
        tableHeader: [
          { prop: "col1", label: "IDC" },
          { prop: "col2", label: "자료유형" },
          { prop: "col3", label: "위치" },
        ],
        tableData: [
          { col1: "목동1센터", col2: "안전교육자료", col3: "1층" },
          { col1: "목동1센터", col2: "안전교육자료", col3: "1층" },
          { col1: "목동1센터", col2: "안전교육자료", col3: "1층" },
        ],
      },
      form: {
        data: {}
      },
    };
  },
  watch: {
    prcssTrtDataCnctId() {
      this.getWrkDatconfresltList(true);
    },
  },
  methods: {
    openModal(type) {
      if(this.isTemplate == false){
        this.dialogKnowledgeView = true
        this.popUpCheck = true
        this.value = true;
        this.onSave();
      }
      //this.$EventBus.$emit("openModal", type);
    },
    checkBoxCheck(){
      if(this.value == true){
        this.onSave();
      }
    },
    getWrkDatconfresltList(flag) {
      if(flag){
        if (this.prcssTrtDataCnctId != null && this.prcssTrtDataCnctId != "") {
          this.currPrcssTrtDataCnctId = this.prcssTrtDataCnctId
        }else{
          if(Object.keys(this.defaultValue).length > 0){
            this.form.data = this.defaultValue;
            this.value = true;
          }
          return;
        }
      }
      this.$BIZ_SERVICE
      .post(this.scrnGetApi,
        { prcssTrtDataCnctId: this.currPrcssTrtDataCnctId, datDivCd:this.datDivCd })
      .then((res) => {
        if (res.data !== "" && res.data.resData != null) {
          this.form.data = res.data.resData;
          this.value = true;
          
        } else {
          this.form.data = {};
        }
      })
      .catch((error) => {
          console.log(error);
      }).finally(()=>{
        
      });
    },
    addReqData(){
      
        this.form.data.exeWflowId  = this.exeWflowId;
        this.form.data.mainPrcssId = this.mainPrcssId;
        this.form.data.subPrcssId  = this.subPrcssId;
        this.form.data.stepCd      = this.$store.getters['wflowStore/getWwflowCurrentStepCd'];
        this.form.data.scrnId      = this.scrnId;
      //this.form.data.scrnActionId = this.scrnActonList //TODO 확인 필요
        this.form.data.trtrId      = this.ticketInfo.trtrId;
        this.form.data.ticktId     = this.ticketInfo.ticktId;
        this.form.data.prcssTrtDataCnctId = this.currPrcssTrtDataCnctId;
        this.form.data.wflowScrnId = this.wflowScrnId;

        this.form.data.datDivCd = this.datDivCd

    },
    onSave() {
      this.addReqData();
      
      this.$BIZ_SERVICE.post(this.scrnPostApi, this.form.data)

      .then((res) => {
        //저장 성공 후 공정처리연결ID 재매핑
        this.currPrcssTrtDataCnctId = res.data.resData

      })
      .catch((error) => {
        console.log(error);
      }).finally(()=>{
          
        this.getWrkDatconfresltList(false);

      });
    },
    chkValidateData() {
      // 공정처리데이터아이디가 있으면 true
      // 단, 목록성 데이터인 경우 로우가 있어야지 true (필수로 있어야하는 데이터라면 체크)
      if(!this.value) return false; 
      if(this.mandDataChkYn != 'Y'){
        return true;
      }else {
        if(this.currPrcssTrtDataCnctId != null && this.currPrcssTrtDataCnctId != ''){
          return true;
        } 
        return false;
      }
    },
    getTemplateData() {
      // 상위 컴포넌트에서 호출
      // Axios로 저장 시 넘겨줄 데이터를 리턴하면 됨.
      return this.form.data;
    },
  },
};
</script>
<style lang="scss" scoped>
.check-popup-list {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  height: 46px;
  border: 1px solid #dadada;
  border-radius: 8px;
  margin-top: 15px;
  div:first-child {
    width: calc(100% - 140px);
  }
  div:last-child {
    width: 140px;
  }
}
</style>
